import { Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { AppService } from '../app/app.service';

export class Vault {
  constructor(config: any) {}
  async setValue(key: string, value: string): Promise<void> {}
  async getValue(key: string): Promise<string> {
    return key;
  }
  async lock(): Promise<void> {}
  async unlock(): Promise<void> {}
  async isLocked(): Promise<boolean> {
    return false;
  }
  async clear(): Promise<void> {}
  onLock(callback: () => void): void {}
  onUnlock(callback: () => void): void {}
}

export interface IdentityVaultConfig {}

class BrowserVault extends Vault {}

@Injectable({
  providedIn: 'root'
})
export class BiometricVaultService {
  private vault: Vault | BrowserVault;

  private state: { locked: boolean } = {
    locked: false
  };

  constructor(
    private platform: Platform,
    private ngZone: NgZone,
    private appService: AppService
  ) {
    if (this.appService.getConfig().security.biometricAuthEnabled) {
      this.vault = this.createBiometricVault();
    }
  }

  async init() {
    if (!this.appService.getConfig().security.biometricAuthEnabled) {
      return;
    }

    await this.platform.ready();

    this.vault.onLock(() => {
      this.ngZone.run(() => {
        this.state.locked = true;
      });
    });

    this.vault.onUnlock(() => {
      this.ngZone.run(() => {
        this.state.locked = false;
      });
    });

    this.state.locked = await this.vault.isLocked();
  }

  /**
   * imposta i dati nel vault
   */
  setVaultData(key: string, value: string): Promise<void> {
    return this.vault.setValue(key, value);
  }

  /**
   * restituisce i dati salvati nel vault;
   * se il vault è bloccato, si aprirà la richiesta di sblocco biometrico
   */
  getVaultData(key: string): Promise<string | null> {
    return this.vault.getValue(key);
  }

  /**
   * blocca il vault
   */
  async lockVault() {
    await this.vault.lock();
  }

  /**
   * sblocca il vault
   */
  async unlockVault() {
    await this.vault.unlock();
  }

  /**
   * pulisce il vault
   */
  async cleanVault() {
    await this.vault.clear();
  }

  /**
   * crea vault biometrico
   */
  private createBiometricVault(): Vault | BrowserVault {
    return this.createVault({
      key: 'io.ionic.biometric',
      type: 'VaultType.DeviceSecurity',
      deviceSecurityType: 'DeviceSecurityType.Biometrics',
      lockAfterBackgrounded: 2000,
      shouldClearVaultAfterTooManyFailedAttempts: true,
      customPasscodeInvalidUnlockAttempts: 2,
      unlockVaultOnLoad: false
    });
  }

  /**
   * crea vault
   */
  private createVault(config: IdentityVaultConfig): Vault | BrowserVault {
    if (Capacitor.getPlatform() === 'web') {
      return new BrowserVault(config);
    } else {
      return new Vault(config);
    }
  }
}
